import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import api from '../../services/api';
import { Category, ProductGlobal } from './useProduct';

const SEARCH_PRODUCT_GLOBAL_BY_BAR_CODE = ['SEARCH_PRODUCT_GLOBAL_BY_BAR_CODE'];

export interface SearchProductGlobalByBarCodeResponse
    extends Pick<
        ProductGlobal,
        | 'cfop'
        | 'ncm'
        | 'cest'
        | 'icms_tax_situation'
        | 'icms_aliquot'
        | 'icms_calculation_basis'
        | 'icms_calculation_basis_mode'
        | 'fiscal'
        | 'pis_cst'
        | 'cofins_cst'
        | 'tax_benefit_code'
    > {
    id: number;
    name: string;
    isGlobal: boolean;
    description?: string | null;
    image_url?: string | null;
    bar_code?: string | null;
    Category?: Category | null;
    providers_global_id?: string | null;
    last_price_in_cents?: string | number | null;
    pis_aliquot?: string | number | null;
    cofins_aliquot?: string | number | null;
    package_multiplier?: string | number | null;
    ibs_cbs_tax_situation?: string | null;
    ibs_cbs_tax_classification?: string | null;
    cbs_aliquot?: string | number | null;
    ibs_uf_aliquot?: string | number | null;
    ibs_mun_aliquot?: string | number | null;
}

export async function fetchProductGlobalByBarCode(barCode: string) {
    try {
        const response = await api.get<SearchProductGlobalByBarCodeResponse>(
            `/products_globals/search-by-bar-code/${barCode}`,
        );
        return response.status === 204 ? null : response.data;
    } catch (error) {
        // The API answers 404 when the barcode is not in the repository
        if (axios.isAxiosError(error) && error.response?.status === 404) {
            return null;
        }
        throw error;
    }
}

export function useSearchProductGlobalByBarCode(barCode: string) {
    const queryFn = () => fetchProductGlobalByBarCode(barCode);

    return useQuery({
        queryFn,
        queryKey: [SEARCH_PRODUCT_GLOBAL_BY_BAR_CODE, barCode],
        enabled: barCode.length > 0,
        refetchOnWindowFocus: false,
        retry: false,
    });
}
